// extracted by mini-css-extract-plugin
export var externalLink = "_dc-0";
export var internalLinkLabel = "_dc-1";